import TextField from '@mui/material/TextField'
import { forwardRef } from 'react'
import { IconButton, InputAdornment } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

type Props = {
  label: string,
  value?: any,
  onChange: any,
  shrink?: boolean,
  required?: boolean,
  type?: string,
  inputProps?: any;
  isPasswordField?: boolean,
  handleVisibility?: () => void,
  visibility?: boolean,
  accept?: string,
  multiline?: boolean,
  rows?: number,
  placeholder?: string,
  error?: boolean,
  helperText?: string,
  disabled?: boolean,
  multiple?: boolean,
}

const InputField = forwardRef<HTMLInputElement, Props>(function InputField({
  multiline,
  rows,
  label,
  value,
  onChange,
  shrink,
  required,
  type,
  inputProps,
  isPasswordField,
  handleVisibility,
  visibility,
  accept,
  placeholder,
  error,
  helperText,
  disabled,
  multiple
}: Props, ref) {
  return (
    <TextField
      multiline={multiline}
      rows={rows}
      id={`${label.toLowerCase().replace(/\s+/g, '-')}-field`}
      label={label}
      variant="outlined"
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      disabled={!!disabled}
      className='text-input-field-component'
      sx={{
        '& fieldset': {
          borderRadius: '8px',
          border: '1px solid #E6E8EF',
        },
        '&:hover fieldset': {
          border: '1px solid #ebac6e !important',
        },
        marginBottom: '16px',
        '& input': {
          fontFamily: 'sofia-regular !important',
          textAlign: 'start',
          color: '#2A2F4E',
        },
        '& textarea': {
          fontFamily: 'sofia-regular !important',
          textAlign: 'start',
          color: '#2A2F4E',
        },
        '&:focus-within fieldset': {
          border: '1px solid #ebac6e !important',
        }
      }}
      InputLabelProps={{
        style: {
          fontSize: '16px',
          color: '#838AA2',
          fontWeight: 400,
        },
        shrink: shrink,
      }}
      inputRef={ref}
      InputProps={{
        ...(value !== '' && isPasswordField ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleVisibility}
                edge="end"
                sx={{ '&:hover': { background: '#e9ecef' } }}
              >
                {visibility ? (
                  <VisibilityOffIcon width='16' height='16' />
                ) : (
                  <VisibilityIcon width='16' height='16' />
                )}
              </IconButton>
            </InputAdornment>
          ),
          classes: { notchedOutline: { border: 'none' } }
        } : inputProps)
      }}
      inputProps={{
        multiple: multiple
      }}
    />
  )
})

export default InputField